<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ac4wsd/tc-custom/9781611174236.jpg?1703426607669" alt="This image is the cover for the book Claws"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Claws
      </h1>
      <p class="bookDescription body article font2">
        <b>A boy meets a bobcat in a South Carolina swamp in this classic adventure story, now with handsome new artwork and a new foreword and introduction.</b><br/><br/>Unseen by readers for a century, Archibald Rutledge’s story “Claws” is a fast-paced adventure tale of a young boy, Paul, lost in the foreboding terrain of Spencer’s Swamp, the domain of the mighty bobcat Claws, who is deftly evading hounds and hunters alike. When Paul and Claws encounter one another at a perilous creek crossing, Rutledge’s mastery of outdoors storytelling shines through in every evocative word.<br/><br/>The short story, originally written for publication in an early twentieth-century boy’s magazine and included in a limited edition collection circa 1913, is now available as a project of South Carolina Humanities for the benefit of literary programs. This new edition of “Claws” is illustrated in handsome charcoal etchings by Southern artist Stephen Chesley. Award-winning outdoors writer and noted Rutledge scholar Jim Casada provides the volume’s introduction and retired South Carolina conservation officer Ben McC. Moïse offers an afterword.<br/><br/>“These books remind us of Mr. Rutledge’s command of the English language, his great skills of observation of the natural world, and his fondness for distilling universal truths from stories of local essence . . . It is good to have Mr. Rutledge with us once more.” —Pat Conroy
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Archibald Rutledge, Jim Casada, Ben McC. Moïse, Stephen Chesley
      </h2>
      
      <p class="authorDescription body article"><P>Archibald Rutledge (1883–1973) was South Carolina's most prolific writer and the state's first poet laureate. His nature writings garnered him the prestigious John Burroughs Medal.</P><br/><br/><P>Jim Casada has written or edited more than forty books, contributed to many others, and authored some five thousand magazine articles. Casada has edited five Rutledge anthologies. A past president of the South Carolina Outdoor Writers Association, the Southeastern Outdoor Press Association, and the Outdoor Writers Association of America, Casada has been honored with more than 150 regional and national writing awards.</P><br/><br/><P>Ben McC. Moïse was recognized with the Guy Bradley Award by the North American Fish and Wildlife Foundation and the Order of the Palmetto for his service as a conservation officer with the South Carolina Department of Natural Resources. He is the author of Ramblings of a Lowcountry Game Warden: A Memoir, and editor of A Southern Sportsman: The Hunting Memoirs of Henry Edwards Davis.</P><br/><br/><P>Stephen Chesley is a semiabstract artist working primarily in oils, charcoal, and metal. His work has been featured in solo and group exhibitions and has been honored with a fellowship from the National Endowment for the Arts. Chesley's previous collaboration with South Carolina Humanities was an illustrated chapbook edition of the Julia Peterkin short story "Ashes" in 2012.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of South Carolina Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18e3344c